
export const environment = {
  production: false,
  title: 'Local Environment',
  // apiURL: 'http://localhost:4000',
  apiURL: "https://akramgroups.com/vaccine/api/v1",
  QRcodeURL: 'http://akramgroups.com/#/check/',
};

